var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22358 3.20163C6.49632 3.15843 6.6824 2.90231 6.6392 2.62957C6.596 2.35682 6.33988 2.17074 6.06714 2.21394C4.42689 2.47373 3.14046 3.76016 2.88067 5.40041C2.83747 5.67316 3.02355 5.92928 3.29629 5.97247C3.56904 6.01567 3.82516 5.82959 3.86836 5.55685C4.06038 4.34449 5.01121 3.39365 6.22358 3.20163Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3335 0.166748C3.74365 0.166748 0.833496 3.0769 0.833496 6.66675C0.833496 10.2566 3.74365 13.1667 7.3335 13.1667C10.9233 13.1667 13.8335 10.2566 13.8335 6.66675C13.8335 3.0769 10.9233 0.166748 7.3335 0.166748ZM1.8335 6.66675C1.8335 3.62918 4.29593 1.16675 7.3335 1.16675C10.3711 1.16675 12.8335 3.62918 12.8335 6.66675C12.8335 9.70431 10.3711 12.1667 7.3335 12.1667C4.29593 12.1667 1.8335 9.70431 1.8335 6.66675Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0204 11.6466C12.8252 11.4513 12.5086 11.4513 12.3133 11.6466C12.1181 11.8418 12.1181 12.1584 12.3133 12.3537L14.9799 15.0203C15.1752 15.2156 15.4918 15.2156 15.687 15.0203C15.8823 14.8251 15.8823 14.5085 15.687 14.3132L13.0204 11.6466Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0c155314c700112e74468b63293daa09.svg";
export { ForwardRef as ReactComponent };